<template>
  <b-skeleton-wrapper :loading="HEADER_LOADING">
    <template #loading>
      <div
        v-for="(item, index) in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]"
        :key="index"
        class="card-list__item"
      >
        <div class="card-list__header border-radius-8">
          <div class="card-list__box">
            <div class="flex-start-between width-percent-100">
              <div class="card-list__image-box w-100">
                <b-skeleton
                  class="width-48 height-48 border-radius-8 margin-left-8"
                  type="avatar"
                ></b-skeleton>
                <div class="width-percent-70">
                  <div class="card-list__title">
                    <b-skeleton width="85%"></b-skeleton>
                  </div>
                  <div class="card-list__caption">
                    <b-skeleton width="100%"></b-skeleton>
                  </div>
                </div>
              </div>
              <b-skeleton
                class="tablet-none desktop-none"
                width="3%"
                type="button"
              ></b-skeleton>
            </div>
            <div class="tablet-none desktop-none flex-start width-percent-100">
              <b-skeleton class="width-48 height-48" type="avatar"></b-skeleton>
            </div>
          </div>
          <div class="card-list__box mobile-none">
            <b-skeleton class="width-48 height-48" type="avatar"></b-skeleton>
          </div>
          <div class="card-list__box mobile-none">
            <span></span>
            <b-skeleton width="3%" type="button"></b-skeleton>
          </div>
        </div>
      </div>
    </template>
    <div>
      <slot name="default"></slot>
    </div>
  </b-skeleton-wrapper>
</template>

<script>
export default {
  inject: ["HEADER_LOADING"],
};
</script>
